<template>
   <div class="h-nav"
        :class="{ 'nav-show': inNav }">
        <div class="nav-main">
            <div class="nav-logo">
                <img src="../../static/assets/image/yt-logo.png" />
            </div>
            <ul class="nav-container">
                <li @click="goNext('home')">
                    <div>
                        <span>首页</span>
                    </div>
                </li>
                <li @mouseenter="handleNav(true, 4)" @mouseleave="handleNav(false)">
                    <div @mouseenter="setCurItem('center')" @mouseleave="setCurItem('')">
                        <span :class="{ 'sub-selected': navType === 'center' }">新闻中心</span>
                        <ul class="expand-list" v-show="curItem === 'center'">
                            <li @click="goNext('news', 'dynamic')">机构动态</li>
                            <li @click="goNext('news', 'info')">行业资讯</li>
                            <li @click="goNext('news', 'party')">党建要闻</li>
                            <li @click="goNext('news', 'story')">视频故事</li>
                        </ul>
                    </div>
                </li>
                <li @mouseenter="handleNav(true, commonwealData.length)" @mouseleave="handleNav(false)">
                    <div @mouseenter="setCurItem('project')" @mouseleave="setCurItem('')">
                        <span :class="{ 'sub-selected': navType === 'project' }">公益项目</span>
                        <ul class="expand-list" v-show="curItem === 'project'">
                            <li @click="goNextHandle(item)" v-for="(item, i) in commonwealData" :key="i" >{{item.name}}</li>
                        </ul>
                    </div>
                </li>
                <li @mouseenter="handleNav(true, 5)" @mouseleave="handleNav(false)">
                    <div @mouseenter="setCurItem('disclosure')" @mouseleave="setCurItem('')">
                        <span :class="{ 'sub-selected': navType === 'disclosure' }">信息披露</span>
                        <ul class="expand-list" v-show="curItem === 'disclosure'">
                            <li @click="goNext('info', 'year')">年度报告</li>
                            <li @click="goNext('info', 'audit')">审计报告</li>
                            <li @click="goNext('info', 'finance')">财务公示</li>
                            <li @click="goNext('info', 'rules')">规章制度</li>
                            <li @click="goNext('info', 'donation')">捐赠情况</li>
                        </ul>
                    </div>
                </li>
                <li @mouseenter="handleNav(true, 5)" @mouseleave="handleNav(false)">
                    <div @mouseenter="setCurItem('intro')" @mouseleave="setCurItem('')">
                        <span :class="{ 'sub-selected': navType === 'intro' }">关于我们</span>
                        <ul class="expand-list" v-show="curItem === 'intro'">
                            <li @click="goNext('about', 'Introduction')">基金会介绍</li>
                            <li @click="goNext('about', 'Organization')">组织架构</li>
                            <li @click="goNext('about', 'Chronicle')">大事记</li>
                            <li @click="goNext('about', 'Honour')">所获荣誉</li>
                            <li @click="goNext('about', 'Contact')">联系方式</li>
                        </ul>
                    </div>
                </li>
                <li @mouseenter="handleNav(true, 3)" @mouseleave="handleNav(false)">
                    <div @mouseenter="setCurItem('volunter')" @mouseleave="setCurItem('')">
                        <span :class="{ 'sub-selected': navType === 'volunter' }">成为志愿者</span>
                        <ul class="expand-list" v-show="curItem === 'volunter'">
                            <li @click="goNext('volunter', 'recruit')">志愿者招募</li>
                            <li @click="goNext('volunter', 'activity')">志愿者活动</li>
                            <li @click="goNext('volunter', 'story')">志愿者故事</li>
                        </ul>
                    </div>
                </li>
            </ul>
            <div :style="{height: inNav ? isHeight : '0'}" class="expand-mask" :class="inNav ? 'mask-show' : 'mask-hide'"></div>
        </div>
    </div>
</template>
<script>
import config from '@/util/config';

export default {
    data() {
        return {
            mouseIn: false,
            curItem: '',
            inNav: false,
            isHeight: 0,
            routeList: {
                news: [
                    'dynamic',
                    'info',
                    'party',
                    'story'
                ],
                commonweal: [
                    'Aid',
                    'plan',
                    'livelihood',
                    'welove',
                    'relief',
                    'other'
                ],
                info: [
                    'year',
                    'audit',
                    'finance',
                    'rules',
                    'donation'
                ],
                volunter: [
                    'recruit',
                    'activity',
                    'story'
                ]
            },
            routeName: ''
        };
    },
    props: {
        navType: {
            type: String,
            default: 'home'
        },
        commonwealData: {
            type: Array
        }
    },
    methods: {
        setCurItem(val) {
            this.curItem = val;
        },
        handleNav(val, num) {
            this.inNav = val;
            if (val) {
                // eslint-disable-next-line no-mixed-operators
                const isHeight = num * 54 + 20;
                this.isHeight = `${isHeight}px`;
            }
        },
        goNext(page, route) {
            this.routeName = '';
            if (page === 'volunter' && route === 'recruit') {
                window.open('http://lxi.me/nqtuk', '_blank');
                return;
            }
            this.$store.commit('common/SET_HAS_THEME', true);
            if (
                (this.navType === 'center' && page === 'news') ||
                (this.navType === 'disclosure' && page === 'info') ||
                (this.navType === 'volunter' && page === 'volunter') ||
                (this.navType === 'intro' && page === 'about')
            ) {
                if (this.$route.name === route) {
                    return;
                }
                this.$emit('handleRouteChange', route);
                this.$router.push({ name: route });
                return;
            }
            let url;
            if (page === 'home') {
                url = `${config.getUrl()}`;
            } else {
                url = route ? `${config.getUrl()}/${page}.html#/${route}` : `${config.getUrl()}/${page}.html`;
            }
            window.location.href = url;
        },
        goNextHandle(item) {
            this.$store.commit('common/SET_HAS_THEME', true);
            if (this.navType === 'project') {
                this.$store.commit('home/SET_WEAL_INFO', item);
                this.$emit('handleRouteChange', 'aid');
                if (this.routeName) return;
                this.$router.push({ name: 'aid' });
                this.routeName = 'aid';
                return;
            }
            this.$store.commit('home/SET_WEAL_INFO', item);
            const url = `${config.getUrl()}/commonweal.html#/aid`;
            window.location.href = url;
        }
    },
    created() {
        if (this.$route.name === 'aid') {
            this.routeName = this.$route.name;
        }
    }
};
</script>
<style lang="scss" scoped>
.h-nav {
    position: fixed;
    display: flex;
    left: 0;
    height: 88px;
    width: 100%;
    flex-direction: row;
    color: #222B45;
    z-index: 99;
    // background: rgba(255, 255, 255, 0.9);
    background: #F7F9FC;
    .nav-main {
        margin: 0 auto;
        width: 1180px;
    }
    .nav-logo {
        position: relative;
        height: 100%;
        width: 322px;
        float: left;
        >img {
            position: absolute;
            top: 50%;
            left: 0%;
            height: 40px;
            width: 322px;
            transform: translateY(-50%);
        }
    }
    .nav-container {
        margin-left: 156px;
        float: left;
        box-sizing: border-box;
        list-style: none;
        >li {
            display: inline-block;
            position: relative;
            padding: 0 24px;
            height: 100%;
            cursor: pointer;
            font-size: 18px;
            line-height: 88px;
            float: left;
            div {
                position: relative;
                font-weight: 500;
                &:hover {
                    span {
                        &::before {
                            content: '';
                            position: absolute;
                            bottom: 13%;
                            left: 0;
                            width: 100%;
                            height: 4px;
                            background: rgba(234, 96, 0, 1);
                            animation: spanAni 0.3s 1;
                        }
                    }
                }
            }
            span {
                padding: 17px 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .expand-list {
        position: absolute;
        top: 88px;
        left: 50%;
        width: 168px;
        transform: translateX(-50%);
        color: #222222;
        animation: expandAni 0.4s 1;
        z-index: 9;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.9);
        li {
            height: 54px;
            text-align: center;
            line-height: 54px;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            &:hover {
                color: rgba(234, 96, 0, 1);
                font-weight: bold;
            }
        }
    }
    .expand-mask {
        display: none;
        position: absolute;
        top: 88px;
        left: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.9);
    }
    .mask-show {
        animation: expandAni 0.3s 1;
    }
    .mask-hide {
        height: 0;
        animation: expandHide 0.3s 1;
    }
    .zh:hover, .en:hover {
        color: #0D6FB8;
    }
}
.sub-selected {
    border-bottom: 4px solid rgba(234, 96, 0, 1);
}

.nav-show {
    .expand-mask {
        display: none;
    }
}

@keyframes expandAni {
    0% {height: 0px;}
}
@keyframes expandHide {
    100% {height: 0px;}
}
@keyframes spanAni {
    0% { width: 0%; }
    100% { width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/h-nav.vue